module.exports = __webpack_public_path__ + "static/media/friends_white.9b9208b9.png";